import React from 'react';
import { createRoot } from 'react-dom/client';

function SuccessModal({ title, message, onClose }) {
  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <div style={styles.iconWrapper}>
          <span className="material-icons" style={styles.checkIcon}>check_circle</span>
        </div>
        <h2 style={styles.title}>{title}</h2>
        <p style={styles.message}>{message}</p>
        <button style={styles.button} onClick={onClose}>Close</button>
      </div>
    </div>
  );
}


export function showSuccess(message, title = 'Success') {
  return new Promise((resolve) => {
    // Create container
    const container = document.createElement('div');
    document.body.appendChild(container);

    // Create root
    const root = createRoot(container);

    // Cleanup and resolve
    const handleClose = () => {
      root.unmount();
      container.remove();
      resolve();
    };

    // Render modal
    root.render(
      <SuccessModal title={title} message={message} onClose={handleClose} />
    );
  });
}

const styles = {
  overlay: {
    position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
    backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
    justifyContent: 'center', alignItems: 'center', zIndex: 2000,
  },
  modal: {
    background: '#fff', borderRadius: 8, padding: 32,
    width:  500, textAlign: 'center', boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
  },
  iconWrapper: {
    width:  68, height: 68, margin: '0 auto 16px',
    borderRadius: '50%', background: '#e6f7ee', display: 'flex',
    alignItems: 'center', justifyContent: 'center',
  },
  checkIcon: {
    fontSize: 48, color: '#16a34a',
  },
  title: {
    margin: '0 0 8px', fontSize: 24, fontWeight: 600, color: '#333',
  },
  message: {
    margin: '0 0 24px', fontSize: 16, color: '#555',
  },
  button: {
    padding: '14px 48px', fontSize: 16, color: '#fff', backgroundColor: '#7c3aed',
    border: 'none', borderRadius: 4, cursor: 'pointer'
  }
};
